import { InfiniteData, QueryClient } from '@tanstack/react-query';
import { create } from '@bufbuild/protobuf';
import { OrderBySchema } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { LoaderFunctionArgs } from 'react-router';
import { createInfinityListIssuesQuery } from '~/shared/api/issues.queries';
import { ensureUserCanSeeIssuesList } from '~/shared/auth/auth-utils';
import { IssuesModel } from '~/shared/models/issues/IssuesModel';
import {
  DEFAULT_ISSUE_STATUS,
  DEFAULT_ORDER,
  DEFAULT_ORDER_BY,
  DEFAULT_ROWS_PER_PAGE,
} from './issues-constants';
import { listSystemsQuery } from '~/shared/api/system.queries';

export const issuesLoader =
  (queryClient: QueryClient) =>
  async ({ request }: LoaderFunctionArgs) => {
    await ensureUserCanSeeIssuesList(queryClient, request);

    const listSystemsReponse =
      await queryClient.ensureQueryData(listSystemsQuery);

    const listIssuesQuery = createInfinityListIssuesQuery({
      pageSize: DEFAULT_ROWS_PER_PAGE,
      orderBy: create(OrderBySchema, {
        field: DEFAULT_ORDER_BY,
        sortOrder: DEFAULT_ORDER,
      }),
      status: DEFAULT_ISSUE_STATUS,
    });

    const infiniteIssuesModel = await queryClient.ensureQueryData({
      queryKey: listIssuesQuery.queryKey,
      queryFn: async (): Promise<InfiniteData<IssuesModel>> => {
        const issuesModel = await listIssuesQuery.queryFn({});
        return {
          pages: [issuesModel],
          pageParams: [undefined],
        };
      },
    });

    return {
      systems: listSystemsReponse,
      listIssues: infiniteIssuesModel,
    };
  };
